import routes from './routes'
import store from './store'

export default {
    name: 'm-maps',
    store: store,
    routes: routes
}